/* saikrishna 11/15/2022 2701012930 Added action rule and created this component
madhu 11/17/2022 2701012930  taken values from add rule group
madhu 11/17/2022 2701012930  taken values from add rule group
Ashraf 11/18/2022 2701012930 Integrated save api for rules
Ashraf 11/21/2022 2701012930 Fixed loader issue
Ashraf 11/22/2022 2701012930 Fixed resetting, toast message issues
Ashraf 11/23/2022 2701012930 Fixed toast message issues.
Prakash 11/23/2022  2701012930  Fixed Alignments issues.
lalitha 11/23/2022 2701012930 fixed page break issue
Ashraf 11/24/2022 2701012930 fixed fetching formula rule data.
Ashraf 11/24/2022 2701012930 modified test Api payload.
Sai krishna 11/25/2022 2701012930 Fixed 400,500 toast message handling.
Akhila 11/29/2022 2701012930 Added new component it will render only its calculation only Test
Guru Prasad 11/29/2022 2701012930 Modified test popup width
Lalitha 11/30/2022 2701012930 Rename Result to Result Expression
Sohel 11/30/2022 2701012930 field List changes
lalitha 12/08/2022 2701012930 Renamed button
akhila 12/12/2022 2701135832 fixed Test issue
akhila 12/14/2022 2701135832 changed selected field
kavyareddy 12/15/2022 2701012930 Added role disable condition
Ashraf 12/15/2022 2701012930 fixed role disable condition
akhila 12/16/2022 2701012930 fixed get api issues
Suresh Peddavoora 12/16/2022 2701012930 Fixed Spacing Alignments for table header
Ashraf 15/16/2022 2701012930 fixed role access
Sohel 12/16/2022 2701012930 Fixed Test button disabled Issue
Raghu 12/18/2022 2701012930 Added new data fields
Sai Maheshwar 12/18/2022 2701012930 Added code and returnType
akhila 12/18/2022 2701012930 Added unsaved changes popup
akhila 12/19/2022 2701012930 increase popup size
akhila 12/21/2022 2701012930 fixed toaster issue
akhila 12/22/2022 2701012930 fixed operators api initial render
akhila 12/23/2022 2701012930 changed test popup title
akhila 12/26/2022 2701012930 fixed payload issue
akhila 12/26/2022 2701012930 fixed placeholder
kavyareddy 12/29/2022 2701012930 Fixed description issue
Ashraf 01/02/2022 2701012930 renamed usage header title
Lalitha 01/05/2023 2701012930 fixed download configuration issue
Lalitha 01/10/2023 2701012930 fixed download configuration  issue
Akhila 01/18/2023 2701012930 unsaved changes popUp bug fixed
Akhila 01/20/2023 2701012930 unsaved chnages stepper issue fixed
manikanta 01/31/2023 2701012930 Result Expression Validation fixed
Akhila 01/31/2023 2701012930 modified Unsaved Changes alert popup
Raghu 02/21/2023 2701012930 changed buttons color
Raghu 04/05/2023 2701012930 fixed input text fields
Prakash  14-04-2023 2701012930 remove marign  issues
Prakash 9/05/2023 2701012930 add theming classname
Akhila 06/21/2023 2701012930 conditionally disable save and finish button on submission
Sohel 10/31/2023 2701012930 Fixed Result Expression Entering Issue
*/

import {
  Typography,
  Button,
  TextField,
  FormHelperText,
} from '@material-ui/core';
import React, {useState, useEffect, useContext, useRef} from 'react';
import {fetchFieldListData} from '../../../../../redux/reducers/GlobalField/AddFieldList';
import DialogBox from '../../../../../components/DialogBox';
import RuleGroupTable from './RuleGroupTable';
import {yupResolver} from '@hookform/resolvers/yup';
import CancelIcon from '@material-ui/icons/Cancel';
import * as Yup from 'yup';
import {
  fetchAllCodeAndDisplayName,
  postBasicInfo,
  fetchRuleGroup,
  resetTestResult,
  fetchAllFunctions,
  postFormulaSelectFields,
  getOperatorsDropdownData,
  ResetAddRule as resetAddRule,
  resetStatus,
} from '../../../../../redux/reducers/BRE/AddRuleGroup';
import {getBaseCategory, resetData} from '../../../../../redux/reducers/GlobalField/AddFieldList';
import {
  resetTestRuleGroupStatus,
  resetFormula,
  resetRuleGroupPrintStatus,
} from '../../../../../redux/reducers/BRE/AddRuleGroup';
import {useDispatch, useSelector} from 'react-redux';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import PageLoader from '../../../../../components/PageLoader';
import AppContext from '../../../../../components/contextProvider/AppContextProvider/AppContext';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import AddIcon from '@material-ui/icons/Add';
import OverrideRule from '../../../../../components/OverrideRule';
import GenerateFields from './TestForm';
import CalculationTestForm from './SearchFieldList/CalculationTestForm';
import AddRule from './AddRule';
import BreadCrums from '../../../../../util/BreadCrum';
import {resetPrintUsageData} from '../../../../../redux/reducers/printUsage';
import {submissionStart} from '../../../../../redux/reducers/CommonActions/commonActions';
import {useForm} from 'react-hook-form';
import {resetMessage} from '../../../../../redux/reducers/EventTactics/EventTactics';

const ActionRule = ({
  setValue,
  setTabValue,
  setSelectedBaseCategory,
  dataReset,
  breCode,
  activeStep,
  setActiveStep,
  handleBack,
  hidden,
  stepSuccessMessage,
  setStepSuccessMessage,
  steps,
  setFieldList,
  setFieldListCode,
  roleData,
  editExisting,
  roleDataAccessDc,
  handleDirty,
}) => {
  useEffect(() => {
    dispatch(resetData());
    dispatch(getBaseCategory());
  }, []);

  const {baseCategoryData} = useSelector(({addFieldList}) => addFieldList);
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState([]);
  const [ruleGroupSNo, setRuleGroupSNo] = useState(1);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);

  const {
    isLoading,
    successMsg,
    errorMsg,
    ruleGroupData,
    addRuleStatus,
    resultByTest,
    addRuleData,
    userMetrix,
    testRuleGroupStatus,
    statusCode,
    basicInfoData,
    isFormulaRuleLoading,
    id,
    downloadSuccessMessage,
  } = useSelector(({addRuleGroup}) => addRuleGroup);
  const {
    isLoading: printUsageIsLoading,
    successMsg: printUsageSuccessMsg,
    errorMsg: printUsageErrorMsg,
  } = useSelector(({printusage}) => printusage);
  const {systemerrorMsg} = useSelector(({systemNotes}) => systemNotes);
  const [dialogState, setDialogState] = useState(false);
  const [deletedRules, setDeletedRules] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [rowData, setRowData] = useState({});
  const [oldRuleCode, setOldRuleCode] = useState('');
  const [selectedFieldList, setSelectedFieldList] = useState(null);
  const [fieldCode, setFieldCode] = useState([]);
  const [overRiding, setOverRiding] = useState({});
  const [openTestForm, setOpenTestForm] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [showTestResult, setshowTestResult] = useState(false);
  const {reportMasterId} = useContext(AppContext);
  const [submit, setSubmit] = useState(false);
  const dirtyRef = useRef(false);

  useEffect(() => {
    dispatch(resetData());
    dispatch(getBaseCategory());
  }, []);
  useEffect(() => {
    setFieldList(null);
    setFieldListCode(null);
  }, []);

  useEffect(() => {
    if(basicInfoData?.groupId){
      dispatch(
        postFormulaSelectFields({
          groupCode: basicInfoData?.code ? basicInfoData?.code : '',
          ruleType: 'Data Calculations',
          filterFormulaRuleGroupId: basicInfoData?.groupId,
        }),
      );
    }
  }, [basicInfoData?.groupId]);

  useEffect(() => {
    if (id) {
      dispatch(fetchRuleGroup(id));
    }
  }, []);
  useEffect(() => {
    if (downloadSuccessMessage) {
      setTimeout(() => {
        dispatch(resetRuleGroupPrintStatus());
      }, 1500);
    }
  }, [downloadSuccessMessage]);

  useEffect(() => {
    if (printUsageSuccessMsg || printUsageErrorMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printUsageSuccessMsg, printUsageErrorMsg]);

  const initialValues = {
    // code: dataReset ? "" : ruleGroupData.code ? ruleGroupData?.code : "",
    // displayName: dataReset ? "" : ruleGroupData.displayName || "",
    // description: dataReset ? "" : ruleGroupData.description || "",
    // returnType: ruleGroupData?.returnType || "",
    result: basicInfoData?.result || '',
    // category: ruleGroupData?.category
    //   ? getCategoryObject(ruleGroupData?.category, baseCategoryData)
    //   : "",
    // fieldList: selectedFieldList
    //   ? selectedFieldList
    //   : ruleGroupData?.fieldListCode
    //     ? ruleGroupData.fieldListCode
    //     : "",
  };
  useEffect(() => {
    dispatch(fetchAllFunctions());
  }, []);
  useEffect(() => {
    setSelectedBaseCategory(basicInfoData?.category);
    setSelectedFieldList(basicInfoData?.filedListCode);
    if (basicInfoData?.fieldListCode) {
      dispatch(fetchFieldListData(basicInfoData?.fieldListCode));
    }
  }, [basicInfoData]);

  useEffect(() => {
    dispatch(fetchAllCodeAndDisplayName());
  }, []);

  useEffect(() => {
    if (!Object.keys(ruleGroupData).length > 0) {
      selectedFieldList && setFormData([]);
    }
  }, [selectedFieldList]);

  const validationSchema = Yup.object().shape({
    result: Yup.string().required('Result Expression is required'),
  });

  const handleClose = () => {
    setOpen(false);
    setIsEditMode(false);
    setRuleGroupSNo(formData?.length);
  };

  const {
    register,
    handleSubmit,
    reset,
    errors,
    getValues,
    watch,
    formState: {isDirty},
    // setValue,
  } = useForm({
    mode: 'onChange',
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    if (isDirty || dirtyRef?.current === true) {
      handleDirty(true);
    } else {
      handleDirty(false, 'reset');
    }
  }, [isDirty, dirtyRef?.current]);

  useEffect(() => {
    if (testRuleGroupStatus === 200) {
      typeof resultByTest === 'object' && resultByTest[0] && setshowTestResult(true);
      dispatch(resetTestRuleGroupStatus());
    }
  }, [testRuleGroupStatus]);
  const handleDialogState = () => {
    setDialogState(false);
  };
  const resultExpression = watch('result');
  useEffect(() => {
    if (Object.keys(basicInfoData).length > 0) {
      reset(initialValues);
      const ruleData =
        basicInfoData.addRule &&
        basicInfoData.addRule.map((data) => {
          const newObj = {
            ...data,
            returnType: data.dataType,
            expression: data.ruleExpression,
            tableData: {checked: true, id: data.ruleId},
            formulaExpression: data?.formulaExpression ? data?.formulaExpression : '',
          };
          delete newObj.dataType;
          delete newObj.ruleExpression;
          return newObj;
        });
      setFormData(ruleData);
    }
  }, [basicInfoData, baseCategoryData]);

  const handleTestFormClose = () => {
    setOpenTestForm(false);
    dispatch(resetTestResult());
  };

  useEffect(() => {
    dispatch(getOperatorsDropdownData());
  }, []);

  useEffect(() => {
    if (addRuleStatus === 200 && userMetrix === 'Yes') {
      setDialogState(true);
      setTimeout(() => {
        dispatch(resetAddRule());
        dispatch(resetFormula());
      }, 2500);
    }
  }, [userMetrix, addRuleStatus]);

  useEffect(() => {
    if (successMsg) {
      setStepSuccessMessage(`${hidden ? steps[1] : steps[2]} added/modified successfully`);
    }
    setTimeout(() => {
      setStepSuccessMessage('');
    }, 2500);
  }, [successMsg]);

  useEffect(() => {
    if (statusCode === 200) {
      setTimeout(() => {
        dispatch(resetMessage());
        dispatch(resetStatus());
        reset({});
        setFormData([]);
        setValue(0);
      }, 2500);

      if (reportMasterId !== '') {
        setTabValue(0);
      }
    } else if ([400, 500].includes(statusCode)) {
      setTimeout(() => {
        dispatch(resetMessage());
        dispatch(resetStatus());
      }, 2500);
    }
  }, [statusCode]);

  const disableEdit = roleData?.window?.['Business Rule Engine']?.['BRE']?.edit;
  const disableDelete = roleData?.window?.['Business Rule Engine']?.['BRE']?.delete;

  useEffect(() => {
    if (basicInfoData?.fieldListCode) {
      dispatch(fetchFieldListData(basicInfoData?.fieldListCode));
    }
  }, [basicInfoData]);

  // const onSubmit = (data) => {
  // if (data) {
  //   const passValues = {
  //     addRule: formData?.map((item) => {
  //       return {
  //         dataType: item.dataType || item.returnType,
  //         groupCode: ruleGroupData?.code
  //           ? ruleGroupData?.code.toUpperCase()
  //           : data.code.toUpperCase(),
  //         ruleExpression: item.ruleExpression || item.expression,
  //         ruleId: dataReset ? 0 : item?.ruleId || 0,
  //       };
  //     }),
  //     deletedId: deletedRules,
  //     code: initialValues.code ? initialValues.code.toUpperCase() : data.code.toUpperCase(),
  //     description: data?.description ? data?.description : "",
  //     displayName: initialValues?.displayName
  //       ? initialValues?.displayName
  //       : data?.displayName
  //         ? data?.displayName
  //         : "",
  //     returnType: data?.returnType ? data?.returnType : "",
  //     groupId: dataReset ? null : ruleGroupData.groupId ? ruleGroupData.groupId : null,
  //     result: data?.result ? data?.result : "",
  //     category: data?.category?.categoryCode ? data?.category?.categoryCode : "",
  //     fieldListCode: selectedFieldList || ruleGroupData?.fieldListCode,
  //     override: "No",
  //     oldFormulaRuleGroupCode: dataReset ? ruleGroupData?.code : "",
  //   };
  // setOverRiding(passValues);
  //   dispatch(postRuleGroup(passValues));
  // };
  const onSubmit = (values) => {
    dispatch(submissionStart());
    const data = {
      ...basicInfoData,
      isDraft: 'N',
      result: values?.result ? values?.result : '',
      category: basicInfoData?.formulaType === 'Create Constant' ? '' : basicInfoData?.category,
      deletedId: deletedRules?.length > 0 ? deletedRules : [],
      addRule: formData?.map((item) => {
        return {
          ruleCode: item?.ruleCode || item?.ruleCode,
          groupCode: basicInfoData?.code ?
            basicInfoData?.code?.toUpperCase() :
            basicInfoData?.code?.toUpperCase(),
          ruleExpression: item?.ruleExpression || item?.expression,
          ruleId: dataReset ? 0 : item?.ruleId || 0,
          formulaExpression: item?.formulaExpression ? item?.formulaExpression : '',
        };
      }),
    };
    setOverRiding(data);
    dispatch(postBasicInfo(data));
  };

  return (
    <>
      <DialogBox
        open={openTestForm}
        dialogClose={handleTestFormClose}
        title={
          <>
            <span>
              <b>{'Run Test For'} :</b>
            </span>
            <span className="result-expression">{resultExpression} </span>
          </>
        }
        maxWidth="lg"
      >
        {basicInfoData?.formulaType === 'Create Constant' ? (
          <CalculationTestForm formData={formData} result={getValues('result')} />
        ) : (
          <GenerateFields
            formData={formData}
            formValues={formValues}
            ruleGroupData={ruleGroupData}
            selectedFieldList={selectedFieldList}
            result={getValues('result')}
            submit={submit}
            setSubmit={setSubmit}
          />
        )}
      </DialogBox>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <div className="d-flex col-12">
          <div>
            <BreadCrums
              name={'Data Calculation Name'}
              code={basicInfoData?.code}
              description={'Data Calculation Description'}
              descriptionValue={basicInfoData?.description}
              returnType={'Return Type'}
              returnTypeValue={basicInfoData?.returnType}
            />
          </div>
        </div>
        <div>
          <div className="table-header table-card-header data-calculation-table new-standard-textfields">
            <Typography variant="h4">Rules</Typography>
            <Button
              variant="outlined"
              // disabled={!disabledByRole}
              className={`search-btn ${classes.buttonRoot}`}
              onClick={() => {
                setOpen(true);
                const reqNo =
                  formData?.length > 0 ?
                    Number(formData[formData?.length - 1].ruleCode?.slice(1)) + 1 :
                    formData?.length + 1;
                setRuleGroupSNo(reqNo);
              }}
            >
              <AddIcon />
              Add Calculation Rule
            </Button>
          </div>
          <RuleGroupTable
            setIsEditMode={setIsEditMode}
            setOldRuleCode={setOldRuleCode}
            setRowData={setRowData}
            rowData={rowData}
            breCode={breCode}
            roleDataAccessDc={roleDataAccessDc}
            setOpen={setOpen}
            disableEdit={disableEdit}
            disableDelete={disableDelete}
            formData={formData}
            setFormData={setFormData}
            deletedRules={deletedRules}
            setDeletedRules={setDeletedRules}
            ruleGroupSNo={ruleGroupSNo}
            editExisting={editExisting}
            dirtyRef={dirtyRef}
          />
        </div>
        <div className="mt-3">
          <div className="form-row new-standard-textfields ">
            <div className="col-8 form-group">
              {resultByTest && showTestResult && (
                <>
                  <TextField
                    className={` ${classes.labelName} ${classes.inputLabel}`}
                    margin="dense"
                    name="testResult"
                    variant="outlined"
                    label="Test Result"
                    value={resultByTest}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    error={Boolean(errors.result?.message)}
                  />
                </>
              )}
            </div>
            <div className="col-2">
              {resultByTest && showTestResult && (
                <CancelIcon
                  onClick={() => {
                    setshowTestResult(false);
                  }}
                />
              )}
            </div>

            <div className="col-sm-6 col-md-8 col-lg-8 form-group">
              <TextField
                className={` ${classes.labelName}`}
                placeholder="Enter Result Expression"
                margin="dense"
                name="result"
                variant="outlined"
                label="Result Expression"
                required
                InputLabelProps={{
                  shrink: true,
                }}
                inputRef={register}
                fullWidth
                error={Boolean(errors.result?.message)}
              />
              <FormHelperText variant="outlined">
                {errors.result?.message ? errors.result.message : ''}
              </FormHelperText>
            </div>
            <div className="col-sm-2 col-md-4 col-lg-4 text-right">
              <Button
                type="button"
                variant="outlined"
                className={`mx-1 search-btn ${classes.buttonRoot}`}
                // disabled={!formData.length || !getValues("result")}
                disabled={!resultExpression}
                color="primary"
                onClick={() => {
                  // handleTest();
                  const vals = getValues();
                  setFormValues(vals);
                  setOpenTestForm(true);
                }}
              >
                Test
              </Button>
            </div>
          </div>
        </div>
        <DialogBox
          open={open || isEditMode}
          dialogClose={handleClose}
          hideFooter={true}
          maxWidth={'xl'}
          title={(isEditMode && 'Edit Calculation Rule ') || (open && 'Add Calculation Rule')}
        >
          <AddRule
            rowData={rowData}
            setFieldCode={setFieldCode}
            setFormData={setFormData}
            formData={formData}
            setOpen={setOpen}
            handleClose={handleClose}
            isEditMode={isEditMode}
            oldRuleCode={oldRuleCode}
            setIsEditMode={setIsEditMode}
            fieldCode={fieldCode}
            ruleGroupSNo={ruleGroupSNo}
            handleDirty={handleDirty}
          />
        </DialogBox>
        <div className="d-flex justify-content-center align-items-center new-standard-textfields">
          <Button
            variant="outlined"
            disabled={activeStep === 0}
            onClick={() => {
              hidden ? setActiveStep(0) : handleBack();
            }}
            className={`reset-btn mr-1 ${classes.buttonRoot}`}
          >
            Back
          </Button>
          <Button
            variant="outlined"
            type="submit"
            disabled={
              formData?.length === 0 ||
              (basicInfoData?.addRule?.length > 0 &&
                roleDataAccessDc?.edit === false &&
                editExisting) ||
              enabledSubmission
            }
            className={`search-btn ml-1 ${classes.buttonRoot}`}
          >
            Finish
          </Button>
        </div>
      </form>
      <OverrideRule
        dialogTitle="Override Business Rule Engine"
        dialogOpen={dialogState}
        dialogClose={handleDialogState}
        title={`This Business Rule Engine has been used in the following places.`}
        data={addRuleData}
        handleOverrideClose={handleDialogState}
        handleOverrideSubmit={() => {
          dispatch(postBasicInfo({...overRiding, override: 'Yes'}));
          handleDialogState();
        }}
      />
      {(isLoading || isFormulaRuleLoading || printUsageIsLoading) && <PageLoader />}
      {(errorMsg || systemerrorMsg || printUsageErrorMsg) && (
        <ErrorSnackbar errorMsg={errorMsg || systemerrorMsg || printUsageErrorMsg} />
      )}
      {(stepSuccessMessage || downloadSuccessMessage || printUsageSuccessMsg) && (
        <SuccessSnackbar
          successMsg={
            stepSuccessMessage ?
              'Calculation Rules added/modified successfully' :
              printUsageSuccessMsg ?
                printUsageSuccessMsg :
                downloadSuccessMessage
          }
        />
      )}
    </>
  );
};

export default ActionRule;
